<template>
    <div class="integration-specific-info-card">
      <tabs
        :tabs="tabs"
        :active-tab="activeTab"
        :tabs-styling="tabsStyling"
        :tabs-labels-styling="tabsLabelsStyling"
        :center-tabs="false"
        @startTabChange="activeTab = $event"
      />
      <div v-if="tabs[activeTab].id === 'custom'" :style="{'height': 'calc(100% - 60px)', 'margin-top': '21px' }">
        <Table
          :checkbox="false"
          :removeTableLines="false"
          :loading="loading"
          :headers="customAuthHeaders"
          :items="custom"
          :add-row-button="false"
          :action-buttons="false"
        />
      </div>
      <div v-if="tabs[activeTab].id === 'auth'" :style="{'height': 'calc(100% - 60px)', 'margin-top': '21px' }">
        <Table
          :checkbox="false"
          :removeTableLines="false"
          :loading="loading"
          :headers="customAuthHeaders"
          :items="auth"
          :add-row-button="false"
          :action-buttons="false"
        />
      </div>
    </div>
  </template>
  
  <script>
  import Tabs from '@/newComponents/_Atoms/Tabs.vue';
  import Table from '@/newComponents/_Molecules/Table';
  
  export default {
    name: "IntegrationSpecificInfo",
  
    components: {
      Tabs,
      Table,
    },
  
    props: {
      auth: {
        type: Array,
        required: true,
      },
  
      custom: {
        type: Array,
        required: true,
      },
    },
  
    data() {
      return {
        activeTab: 0,
        tabsStyling: {
          'margin': '0px 0px 8px 0px',
          'width': '100%',
          'height': '39px',
        },
        tabsLabelsStyling: {
          'text-transform': 'none',
          'font-size': '10px',
          'letter-spacing': '0',
        },
        loading: false,
      }
    },
  
    computed: {
      customAuthHeaders() {
        return [
          {
            text: this.$i18n.tc('Attribute',1),
            varName: "attribute",
            editable: false,
          },
          {
            text: this.$i18n.tc('Value',1),
            varName: "value",
            editable: false,
          },
        ]
      },
  
      tabs() {
        return [
          {
            id: 'custom',
            label: this.$i18n.t("Custom"),
          },
          {
            id: 'auth',
            label: this.$i18n.t("Auth"),
          }
        ]
      },
    },
  }
  </script>
  
  <style scoped>
  .integration-specific-info-card {
    box-shadow: 0px 2px 2px 0px rgba(0, 0, 0, 0.25);
    border-radius: 8px;
    padding: 17px 21px;
    flex: 1;
    position: relative;
    height: auto;
    max-height: 71%;
  }
  
  </style>


// WEBPACK FOOTER //
// src/newComponents/Integrations/IntegrationSpecificInfo.vue